// GETTERS
export const PARAMS_TO_SEND = 'strategies/PARAMS_TO_SEND'
export const PARTNERS = 'strategies/PARTNERS'
export const STRATEGY_ETR_LIST = 'strategies/STRATEGY_ETR_LIST'
export const SELECTED_COUNTRIES = 'strategies/SELECTED_COUNTRIES'
export const SELECTED_COUNTRIES_EDIT = 'strategies/SELECTED_COUNTRIES_EDIT'
export const SELECTED_PARTNERS = 'strategies/SELECTED_PARTNERS'

// MUTATIONS
export const SET_PAGINATION = 'strategies/SET_PAGINATION'
export const SET_TOTAL_ITEMS = 'strategies/SET_TOTAL_ITEMS'
export const SET_FILTERS = 'strategies/SET_FILTERS'
export const SET_PARTNERS = 'strategies/SET_PARTNERS'
export const SET_IS_ETR_LOADING = 'strategies/SET_IS_ETR_LOADING'
export const SET_STRATEGIES_ETR = 'strategies/SET_STRATEGIES_ETR'

export const SET_IS_ETP_LOADING = 'strategies/SET_IS_ETP_LOADING'
export const SET_STRATEGIES_ETP = 'strategies/SET_STRATEGIES_ETP'

// ACTIONS
export const CHANGE_PAGINATION = 'strategies/CHANGE_PAGINATION'
export const CHANGE_FILTERS = 'strategies/CHANGE_FILTERS'
export const RESET_PAGINATION = 'strategies/RESET_PAGINATION'
export const GET_PARTNERS = 'strategies/GET_PARTNERS'
export const GET_STRATEGIES_ETR = 'strategies/GET_STRATEGIES_ETR'
export const GET_STRATEGIES_ETP = 'strategies/GET_STRATEGIES_ETP'
